import styled from 'styled-components';
import { Form } from 'components/ui/Form';
import Button from 'components/ui/Button';

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  margin-top: 20px;
`;
export const StyledButton = styled(Button)`
  width: 200px;
  margin-top: 10px;
`;
